import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_12: FaireProductEntity = {
  token: "atc_nf_chunks_12",
  type: "product",
  name: "Pick Comb in Flare",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/products/comb-pick-flare-WBG-web-1-crop.jpg?v=1655180834",
  priceDollars: 5.95,
  msrpDollars: 12,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
